const env = import.meta.env.VITE_NODE_ENV
const PROD = env === 'prod'

export const employee = {
  DEFAULT_MANAGED_BY: {
    SHIPPER: PROD ? "E00497" : "E01168", // PROD: Shenaz 
    CARRIER: PROD ? "E01183" : "E01168"  // PROD: Syed
  },
  CONTACT: {
    SHARE: {
      name: "",
      mobile: "+971 42563379" // Shenaz
    }
  },
  ROLE: {
    ADMIN: 1,
    OPS: 2,
    SALES: 3,
    FINANCE: 4,
    OPS_MANAGER: 5,
    ONBOARDING: 6,
    SALES_MANAGER: 7
  },
  GET_ROLE_NAME: {
    "1": "Admin",
    "2": "Operations",
    "3": "Sales",
    "4": "Finance",
    "5": "Ops Manager",
    "6": "Onboarding",
    "7": "Sales Manager"
  },
  COUNTRY: {
    "1": "United Arab Emirates",
    "2": "KSA",
    "3": "Oman",
    "4": "Qatar",
    "5": "Kuwait",
    "6": "Bahrain",
    "7": "Gaza",
    "8": "Jordan",
    "9": "Yemen",
    "10":"Saudi Arabia"
  }
}
